const benefits = [
  {
    icon: 'ri-money-dollar-circle-line',
    title: '등록비·가입비 없음',
    desc: '별도 비용 없이 무료로 가족간병 등록이 가능합니다.',
    img: 'https://cdn.imweb.me/thumbnail/20251205/afbba8868fa5b.png',
  },
  {
    icon: 'ri-infinity-line',
    title: '한번 등록으로 평생 사용',
    desc: '한 번 등록하면 추가 절차 없이 평생 이용 가능합니다.',
    img: 'https://cdn.imweb.me/thumbnail/20251205/51d731844b38e.png',
  },
  {
    icon: 'ri-map-pin-2-line',
    title: '전국 어디서든 서류발급',
    desc: '전국 어디서든 필요한 서류를 발급받을 수 있습니다.',
    img: 'https://cdn.imweb.me/thumbnail/20251205/9a75283c9664b.png',
  },
];

export default function BenefitsSection() {
  return (
    <section className="w-full py-16" style={{ backgroundColor: '#f9fdfb' }}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-xs font-semibold tracking-widest uppercase mb-2" style={{ color: '#2E7D6B' }}>WHY KOREA CARERS</p>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900">코리아케어러스를 선택해야 하는 이유</h2>
        </div>

        {/* Horizontal card strip - 간병이지와 다른 가로 배치 강조 스타일 */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {benefits.map((b, i) => (
            <div
              key={i}
              className="relative rounded-2xl overflow-hidden group cursor-pointer"
              style={{ height: '260px' }}
            >
              <img
                src={b.img}
                alt={b.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div
                className="absolute inset-0"
                style={{ background: 'linear-gradient(to top, rgba(13,43,36,0.9) 0%, rgba(13,43,36,0.3) 60%, transparent 100%)' }}
              ></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div
                  className="w-9 h-9 flex items-center justify-center rounded-xl mb-3"
                  style={{ backgroundColor: 'rgba(46,125,107,0.8)' }}
                >
                  <i className={`${b.icon} text-white text-base`}></i>
                </div>
                <p className="text-white font-bold text-base mb-1">{b.title}</p>
                <p className="text-white/60 text-xs leading-relaxed">{b.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
